import { FeaturedProduct } from "@jog/types"
import { asLink, isFilled } from "@prismicio/helpers"
import { ImageField, LinkField } from "@prismicio/types"
import React, { useContext } from "react"

export type FeaturedProductsContextType = {
    products: FeaturedProduct[]
}

export const FeaturedProductsContext = React.createContext<FeaturedProductsContextType>({
    products: [],
})

export const useFeaturedProducts = () => useContext(FeaturedProductsContext)

export interface FeaturedValidProduct extends FeaturedProduct {
    cover: ImageField
    url: string
    target?: string
}
export const toFeaturedValidProduct = (
    item: { product_link: LinkField; cover: ImageField },
    product: FeaturedProduct
): FeaturedValidProduct => {
    return {
        cover: item.cover,
        url: asLink(item.product_link) || "",
        target:
            isFilled.link(item.product_link) && item.product_link.link_type === "Web" ? item.product_link.target : "",
        ...product,
    }
}
